import AlertDialog from '../../AlertDialog';
import { Box } from '../../Grid';

export const ConversionDialog = ({ isOpen, modalText, onDismiss }) => (
  <AlertDialog
    ariaLabel="Exchange message"
    onDismiss={onDismiss}
    isOpen={isOpen}
    id="gtm-linkpoints-exchange"
  >
    <Box data-testid="conversion-dialog" textAlign="center">
      <h2
        css={`
          color: #73308a;
        `}
      >
        {modalText.title}
      </h2>
      {modalText.bodyIsHtml ? (
        /* only the partner's own message, which carries a link to their support page */
        <p dangerouslySetInnerHTML={{ __html: modalText.body }} />
      ) : (
        <p>{modalText.body}</p>
      )}
    </Box>
  </AlertDialog>
);
